import React, { useState } from 'react';
import { FormGroup, FormControlLabel } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import './PageHeader.css';
import usePageHeaderStyles from "./pageHeader.style"

// const RadioButton = withStyles({
//     root: {
//         color: "#354052e6",
//         '&$checked': {
//             color: "#354052e6",
//         },
//     },
// //     checked: {},
// })((props) => <Radio color="default" {...props} />);
const PageHeader = (props) => {
    const { report, onChange, defaultValue } = props;
    const [selected, setSelected] = useState(defaultValue);
    const classes = usePageHeaderStyles()
    React.useEffect(() => {
        // setSelected(report[0])
    }, [defaultValue])
    React.useEffect(() => {
        onChange(selected)
    }, [selected])
    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            <h6>TV Weekly Schedule (In Minutes)</h6>
            <p style={{ paddingRight: 10 }}>Report Type :</p>
            <FormGroup row>
                {report.map(item => {
                    return (
                        <React.Fragment key={item} >
                            <FormControlLabel
                                style={{ display: "flex", fontSize: 10 }}
                                classes={{ label: classes.label }}
                                control={
                                    <Radio
                                        classes={{ root: classes.radioRoot }}
                                        size="small"
                                        name={item}
                                        checked={selected === item}
                                        value={item}
                                        color="primary"
                                        onChange={e => setSelected(item)}
                                    />
                                }
                                label={item}
                            />
                        </React.Fragment>
                    )

                })}
            </FormGroup>
        </div>
    );
}


export default PageHeader;